<div class="page-content">
    <div class="page-header">
        <h1>{{ title }}</h1>
        <div class="page-description">{{ subTitle }}</div>
    </div>
    <div class="page-body">
        <div class="container-fluid cards-container">
            @let kpi = kpis()[0];
            <div class="row g-3">
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.connectionsWithdrawalTotal.title"
                        [body]="{
                            value: kpi.connectionsWithdrawalTotal,
                            precision: texts.connectionsWithdrawalTotal.precision,
                        }"
                        [badge]="{
                            value: kpi.connectionsWithdrawalTotalEvolution,
                            suffix: texts.connectionsWithdrawalTotal.badgeSuffix,
                            precision: texts.connectionsWithdrawalTotal.badgePrecision,
                            style:
                                kpi.connectionsWithdrawalTotalEvolution! > 0 ? 'success' : 'danger',
                        }"
                        [descriptionTitle]="texts.connectionsWithdrawalTotal.descriptionTitle"
                        [descriptionContent]="texts.connectionsWithdrawalTotal.descriptionContent"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'connectionsWithdrawalTotal')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.connectionsInjectionTotal.title"
                        [body]="{
                            value: kpi.connectionsInjectionTotal,
                            precision: texts.connectionsInjectionTotal.precision,
                        }"
                        [badge]="{
                            value: kpi.connectionsInjectionTotalEvolution,
                            suffix: texts.connectionsInjectionTotal.badgeSuffix,
                            precision: texts.connectionsInjectionTotal.badgePrecision,
                            style:
                                kpi.connectionsInjectionTotalEvolution! > 0 ? 'success' : 'danger',
                        }"
                        [descriptionTitle]="texts.connectionsInjectionTotal.descriptionTitle"
                        [descriptionContent]="texts.connectionsInjectionTotal.descriptionContent"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'connectionsInjectionTotal')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.connectionsInfraNumber.title"
                        [body]="{
                            value: kpi.connectionsInfraNumber,
                            precision: texts.connectionsInfraNumber.precision,
                        }"
                        [badge]="{
                            value: kpi.connectionsInfraNumberEvolution,
                            suffix: texts.connectionsInfraNumber.badgeSuffix,
                            precision: texts.connectionsInfraNumber.badgePrecision,
                            style: kpi.connectionsInfraNumberEvolution! > 0 ? 'success' : 'danger',
                        }"
                        [descriptionTitle]="texts.connectionsInfraNumber.descriptionTitle"
                        [descriptionContent]="texts.connectionsInfraNumber.descriptionContent"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'connectionsInfraNumber')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.powerInjectionConnections.title"
                        [body]="{
                            value: kpi.powerInjectionConnections,
                            precision: texts.powerInjectionConnections.precision,
                        }"
                        [badge]="{
                            value: kpi.powerInjectionConnectionsEvolution,
                            suffix: texts.powerInjectionConnections.badgeSuffix,
                            precision: texts.powerInjectionConnections.badgePrecision,
                            style:
                                kpi.powerInjectionConnectionsEvolution! > 0 ? 'success' : 'danger',
                        }"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'powerInjectionConnections')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
            </div>

            <chart-card
                id="enedisConnectionsCountChart"
                [title]="texts.connectionsCountChart.title"
                [error]="connectionsCountChartError"
                [isLoading]="!connectionsCountChartData()[0].organizationId"
                [series]="connectionsCountChartSeries"
                [dataLabels]="connectionsCountDataLabels"
                [stacked]="true"
                [xaxisCategories]="connectionsCountXaxisCategories"
                [yaxis]="connectionsCountYaxis"
                [xaxisTitle]="texts.connectionsCountChart.xaxisTitle"
                class="h-100">
            </chart-card>

            <chart-card
                id="enedisConnectionsProducersCountChart"
                [title]="texts.connectionsProducersCountChart.title"
                [error]="connectionsProducersCountChartError"
                [isLoading]="!connectionsProducersCountChartData()[0].organizationId"
                [series]="connectionsProducersCountChartSeries"
                [dataLabels]="connectionsProducersCountDataLabels"
                [stacked]="true"
                [xaxisCategories]="connectionsProducersCountXaxisCategories"
                [yaxis]="connectionsProducersCountYaxis"
                [xaxisTitle]="texts.connectionsProducersCountChart.xaxisTitle"
                [customTooltip]="connectionsProducersCountCustomTooltip"
                [legend]="connectionsProducersCountLegend"
                class="h-100">
            </chart-card>

            <chart-card
                id="enedisConnectionsEstimationNoticeChart"
                [title]="texts.connectionsEstimationNoticeChart.title"
                [error]="connectionsEstimationNoticeChartError"
                [isLoading]="!connectionsEstimationNoticeChartData()[0].organizationId"
                [series]="connectionsEstimationNoticeChartSeries"
                [dataLabels]="connectionsEstimationNoticeDataLabels"
                [xaxisCategories]="connectionsEstimationNoticeXaxisCategories"
                [yaxis]="connectionsEstimationNoticeYaxis"
                [grid]="connectionsEstimationNoticeGrid"
                [xaxisTitle]="texts.connectionsEstimationNoticeChart.xaxisTitle"
                [precision]="texts.connectionsEstimationNoticeChart.precision"
                class="h-100">
            </chart-card>

            <chart-card
                id="enedisConnectionsCommissioningRateChart"
                [title]="texts.connectionsCommissioningRateChart.title"
                [error]="connectionsCommissioningRateChartError"
                [isLoading]="!connectionsCommissioningRateChartData()[0].organizationId"
                [series]="connectionsCommissioningRateChartSeries"
                [dataLabels]="connectionsCommissioningRateDataLabels"
                [xaxisCategories]="connectionsCommissioningRateXaxisCategories"
                [yaxis]="connectionsCommissioningRateYaxis"
                [plotOptions]="connectionsCommissioningRatePlotOptions"
                [type]="'bar'"
                [height]="600"
                class="h-100">
            </chart-card>
        </div>
    </div>
</div>
